import Footer from "../Website/Footer"
import { TiTick } from "react-icons/ti";
import { Link } from "react-router-dom";
import Navbar from "../Website/NavBar"
import imageOne from "../../Images/sv-three.png"
import imageTwo from "../../Images/sv-one.png"
import imageThree from "../../Images/sv-two.png"
import SeoMeta from "../../Component/Seo";

const VendorCompliance = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Vendor Compliance Services",
    "provider": {
      "@type": "Organization",
      "name": "GRC@Pulse",
      "url": "https://grcpulse.in"
    },
    "areaServed": {
      "@type": "Country",
      "name": "India"
    },
    "description": "Centralize your vendor compliance management in one platform. Track, monitor, and automate vendor documentation and workflows."
  };

  return (
    <>
      <SeoMeta
        title="All-in-One Vendor Compliance Platform | Centralized Control"
        description="Centralize your vendor compliance management in one platform. Track, monitor, and automate vendor documentation and workflows."
        url="https://grcpulse.in/services/vendor-compliance"
        image="https://grcpulse.in/images/vendor-compliance-banner.png"
        type="service"
        canonical="https://grcpulse.in/services/vendor-compliance"
        siteName="GRC@Pulse"
        schemaJSONLD={schema}
      />
      <Navbar />
      <div className="xl:p-4 pt-2  bg-primary-color h-[500px] xl:h-[400px] bg-opacity-20 grid grid-cols-1 lg:grid-cols-2">
        <div className="flex flex-col justify-center">
          <h1 className="text-2xl text-primary-color text-center font-bold">
            Vendor Compliance
          </h1>
          <h1 className="leading-6 text-center mt-2">
            Track multiple vendors of their adherence to statutory regulations, contractual obligations, and compliance requirements essential for risk-free and efficient operations with GRC@Pulse, your trusted partner in Vendor Compliance Assurance.
          </h1>

          <div className="flex flex-col xl:flex-row lg:flex-row gap-2 justify-center items-center mt-2 text-sm text-primary-color">
            <h1 className="flex items-center gap-1">
              <TiTick fontSize="1rem" /> <span>Vendor audits</span>
            </h1>
            <h1 className="flex items-center gap-1">
              <TiTick fontSize="1rem" /> <span>Documentation review</span>
            </h1>
            <h1 className="flex items-center gap-1">
              <TiTick fontSize="1rem" /> <span>Training</span>
            </h1>
          </div>

          <div className="mt-4 flex justify-center">
            <Link to="/contact-us">
              <button className="p-2 bg-primary-color text-white rounded-md shadow-lg hover:bg-danger transition duration-300">
                Contact Us
              </button>
            </Link>
          </div>
        </div>

        <div className="hidden lg:flex justify-center items-center mt-5">
          <img src={imageOne} alt="GRC@Pulse Compliance" className="w-[350px] h-[350px]" />
        </div>

      </div>

      <div className="mt-4 px-[10px] xl:px-[100px] grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2">
        <div className="flex justify-center xl:justify-start">
          <img src={imageThree} alt="GRC@Pulse Compliance" className="w-[350px] h-[350px]" />
        </div>
        <div>
          <h1 className="font-bold text-primary-color text-xl">
            Benefits of Vendor Compliance
          </h1>
          <div className="flex gap-2 mt-2 items-center">
            <span className="w-[5px] h-[45px] bg-primary-color block"></span>
            <div>
              <h1 className="font-bold">Legal Safeguard:</h1>
              <h1 className="mt-1"> Avoid penalties and legal liabilities arising from subcontractors' non-compliance.</h1>
            </div>
          </div>
          <div className="flex gap-2 mt-4 items-center">
            <span className="w-[5px] h-[45px] bg-primary-color block"></span>
            <div>
              <h1 className="font-bold"> Reputation Management:</h1>
              <h1 className="mt-1"> Build trust and a strong reputation as a socially responsible employer.</h1>
            </div>
          </div>
          <div className="flex gap-2 mt-4 items-center">
            <span className="w-[5px] h-[45px] bg-primary-color block"></span>
            <div>
              <h1 className="font-bold"> Operational Continuity:</h1>
              <h1 className="mt-1"> Prevent disruptions caused by non-compliance-related legal issues.</h1>
            </div>
          </div>
          <div className="flex gap-2 mt-4 items-center">
            <span className="w-[5px] h-[45px] bg-primary-color block"></span>
            <div>
              <h1 className="font-bold"> Workforce Safety:  </h1>
              <h1 className="mt-1"> Ensure a safe and fair work environment for all workers on your premises.</h1>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col md:flex-row-reverse px-4 mt-4 gap-6 items-center">
        <div className="w-full md:w-1/2 flex justify-center md:justify-end xl:justify-end">
          <img src={imageTwo} alt="" className="w-[300px] md:w-[400px] xl:w-[450px] h-auto" />
        </div>

        <div className="w-full md:w-1/2">
          <h1 className="font-bold text-primary-color text-xl">
            Key Areas of Vendor Compliance
          </h1>

          <div className="flex gap-2 mt-2 items-center">
            <span className="w-[5px] h-[45px] bg-primary-color block"></span>
            <h1 className="font-bold">Contract Labor (Regulation and Abolition) Act, 1970</h1>
          </div>

          <div className="flex gap-2 mt-2 items-center">
            <span className="w-[5px] h-[45px] bg-primary-color block"></span>
            <h1 className="font-bold">Labor Welfare Fund (LWF)</h1>
          </div>

          <div className="flex gap-2 mt-2 items-center">
            <span className="w-[5px] h-[45px] bg-primary-color block"></span>
            <h1 className="font-bold">Health, Safety, and Welfare</h1>
          </div>

          <div className="flex gap-2 mt-2 items-center">
            <span className="w-[5px] h-[45px] bg-primary-color block"></span>
            <h1 className="font-bold">Equal Remuneration Act, 1976</h1>
          </div>

          <div className="flex gap-2 mt-2 items-center">
            <span className="w-[5px] h-[45px] bg-primary-color block"></span>
            <h1 className="font-bold">Maternity Benefit Act, 1961</h1>
          </div>

          <div className="flex gap-2 mt-2 items-center">
            <span className="w-[5px] h-[45px] bg-primary-color block"></span>
            <h1 className="font-bold">Workmen’s Compensation Act, 1923</h1>
          </div>

          <div className="flex gap-2 mt-2 items-center">
            <span className="w-[5px] h-[45px] bg-primary-color block"></span>
            <h1 className="font-bold">Attendance and Work Hour Records</h1>
          </div>

          <div className="flex gap-2 mt-2 items-center">
            <span className="w-[5px] h-[45px] bg-primary-color block"></span>
            <h1 className="font-bold">Grievance Redressal Mechanism</h1>
          </div>

          <div className="flex gap-2 mt-2 items-center">
            <span className="w-[5px] h-[45px] bg-primary-color block"></span>
            <h1 className="font-bold">Licenses and Approvals</h1>
          </div>
        </div>
      </div>

      <Footer />
    </>)
}

export default VendorCompliance